// extracted by mini-css-extract-plugin
export var active = "_ic-7";
export var blink = "_ic-8";
export var dropDownSelector = "_ic-4";
export var dropDownWrapper = "_ic-3";
export var fakeCursor = "_ic-6";
export var fontSizeButton = "_ic-9";
export var formQuillEditor = "_ic-0";
export var pressed = "_ic-a";
export var qlBlank = "_ic-1";
export var textFormattingToolbar = "_ic-2";
export var textToolbarOption = "_ic-5";